/**
 * Функции для проверки вводимых данных
 */

var integerKeys = [8, 9, 13, 35, 36, 37, 39, 46, 110];
var floatKeys = [8, 9, 13, 35, 36, 37, 39, 46, 110, 188, 190, 108];

/**
 * Проверка на целое число
 * @ параметр: e - event
 * Результат: true, если вводимый символ допустим, false - если нет
 */
function integerInput(el, e) {
    // Backspace, tab, enter, end, home, left, right,decimal(.)in number part, decimal(.) in alphabet
    // We don't support the del key in Opera because del == . == 46.
    var controlKeys = integerKeys;
    // IE doesn't support indexOf
    var controlKeysTest = '#'+controlKeys.join('#')+'#';
    var isControlKey = controlKeysTest.match(new RegExp('#'+e.which+'#'));
    // Some browsers just don't raise events for control keys. Easy.
    // e.g. Safari backspace.
    if ((e.which > 0) && // Control keys in most browsers. e.g. Firefox tab is 0
        (
            (49 <= e.which && e.which <= 57) || // Always 1 through 9
            (96 <= e.which && e.which <= 106) || // Always 1 through 9 from number section
            (48 == e.which) || // No 0 first digit
            (96 == e.which) || // No 0 first digit from number section
            isControlKey)
        ) { // Opera assigns values for control keys.
        return true;
    } else {
        e.preventDefault();
    }
}

/**
 * Проверка на дробное число
 * @ параметр: e - event
 * Результат: true, если вводимый символ допустим, false - если нет
 */
function floatInput(el,e) {
    // Backspace, tab, enter, end, home, left, right,decimal(.)in number part, decimal(.) in alphabet
    // We don't support the del key in Opera because del == . == 46.
    var controlKeys = floatKeys;

    // IE doesn't support indexOf
    var controlKeysTest = '#'+controlKeys.join('#')+'#';
    var isControlKey = controlKeysTest.match(new RegExp('#'+e.which+'#'));
    console.log(e.which);
    // Some browsers just don't raise events for control keys. Easy.
    // e.g. Safari backspace.
    if ((e.which > 0) && // Control keys in most browsers. e.g. Firefox tab is 0
        (
            (49 <= e.which && e.which <= 57) || // Always 1 through 9
            (96 <= e.which && e.which <= 106) || // Always 1 through 9 from number section
            (48 == e.which) || // No 0 first digit
            (96 == e.which) || // No 0 first digit from number section
            isControlKey)
        ) { // Opera assigns values for control keys.
        return;
    } else {
        e.preventDefault();
    }
}

export { integerInput, floatInput };
